import * as React from 'react';
import { useParams } from 'react-router-dom';

import { transformContentGoals } from 'base/api/utils';
import { Meditation } from 'base/api/types';
import { STATUSES_OPTIONS } from 'common/consts';
import { PK } from 'common/types';
import { DetailsCard, DetailsSuspense } from 'templates/details';

import MeditationCore from '../components/MeditationCore';
import { fields, MeditationFields } from '../consts';
import { useMeditationDetails } from '../queries';

const transformMeditation = (raw: Meditation): MeditationFields => ({
  [fields.title.name]: raw.title,
  [fields.description.name]: raw.description,
  [fields.status.name]: STATUSES_OPTIONS.filter(({ value }) => value === raw.status),
  [fields.content_goals.name]:
    raw.content_goals && transformContentGoals(raw.content_goals),
  [fields.media_file_pk.name]: [raw.media_file],
  [fields.is_featured.name]: raw.is_featured,
  [fields.is_inspiration.name]: raw.is_inspiration,
});

const MeditationsDetails = () => {
  const { pk } = useParams<{ pk?: PK }>();
  const { data, ...query } = useMeditationDetails(pk);
  const defaultValues = data && transformMeditation(data);

  return (
    <DetailsCard created={data?.created_at} lastUpdate={data?.modified_at}>
      <DetailsSuspense isLoading={query.isLoading} error={query.error}>
        <MeditationCore key={pk} pk={pk} defaultValues={defaultValues} />
      </DetailsSuspense>
    </DetailsCard>
  );
};

export default MeditationsDetails;
